// Legacy BillingGroup serialization includes non camelcase properties
/* eslint-disable camelcase */
import Immutable from 'immutable'
import { createSelector } from 'reselect'

import createBillingGroup from '../../records/BillingGroup'
import { constants as clientConstants } from './client'

// ------------------------------------
// Constants
// ------------------------------------

// ------------------------------------
// Actions
// ------------------------------------

// ------------------------------------
// Selectors
// ------------------------------------
export const selectBillingGroups = createSelector(
  state => state.get('groups'),
  (state, billingGroupIds) => billingGroupIds,
  (groups, billingGroupIds) => groups.filter(group => billingGroupIds.includes(group.get('id'))),
)

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  groups: Immutable.Set(),
})

function buildGroupsFromClientResponse(oldGroups, clients) {
  const groups = clients.reduce(
    (newGroups, { billing_groups = [] }) => newGroups.union(billing_groups),
    Immutable.Set(),
  )

  return groups.reduce((newGroups, group) => {
    const newGroup = createBillingGroup(group)

    return replaceGroup(newGroups, newGroup)
  }, oldGroups)
}

function replaceGroup(groups, group) {
  return groups
    .filter(search => search.get('id') !== group.get('id'))
    .add(group)
}

export default function reducer(state = initialState, action) {
  const { payload } = action

  switch (action.type) {
    case clientConstants.RECEIVE_CLIENTS:
      return state.set('groups', buildGroupsFromClientResponse(state.get('groups'), payload.clients))

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/billingGroup.js